<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">Multicast Profile {{ profileId }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current multicast profile entry." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Multicast Profile Entry'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkAdd()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAllEntry"
                  />
                  <label for="idSelectAllEntry"></label>
                </th>
                <th
                  v-for="(value, key) in multicastEntryTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in multicastEntryTable.data"
                :key="row.profileid"
                :class="{ 'true:': true }"
                @click=""
              >
                <td width="40px">
                  <div v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelectEntry' + index"
                    />
                    <label :for="'idRowSelectEntry' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.index }}</div>
                </td>
                <td>
                  <div>{{ row.type }}</div>
                </td>
                <td>
                  <div>{{ row.startip }}</div>
                </td>
                <td>
                  <div>{{ row.endip }}</div>
                </td>
                <td>
                  <div>{{ row.srcip }}</div>
                </td>
                <td>
                  <div>{{ row.vlan }}</div>
                </td>
                <td>
                  <div>{{ row.port }}</div>
                </td>
                <td>
                  <div
                    @click="getEntryInfo(row.index)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!--配置操作-->
          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Multicast Profile Entry Edit'"
              @close="isShowAddTable = false"
              :scroll="true"
              style="min-height: 100%"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="index"
                    >Index</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'index',
                        multicastEntryForm.index
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="index"
                      :disabled="isEditClik"
                      v-model="multicastEntryForm.index"
                      placeholder="INTEGER<0-127>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'index',
                          multicastEntryForm.index
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("index", multicastEntryForm.index) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="accesstype"
                    >Type</label
                  >
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="accesstype"
                      v-model="multicastEntryForm.type"
                    >
                      <option label="permit" value="2"></option>
                      <option label="preview" value="3"></option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="startip"
                    >Start IP</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'ip',
                        multicastEntryForm.startip
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="startip"
                      v-model="multicastEntryForm.startip"
                      placeholder="224.0.1.0-239.255.255.255"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'ip',
                          multicastEntryForm.startip
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("ip", multicastEntryForm.startip) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="endip"
                    >End IP</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'ip',
                        multicastEntryForm.endip
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="endip"
                      v-model="multicastEntryForm.endip"
                      placeholder="224.0.1.0-239.255.255.255"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters('ip', multicastEntryForm.endip)
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("ip", multicastEntryForm.endip) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="srcip"
                    >Src IP</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'ip',
                        multicastEntryForm.srcip
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="srcip"
                      v-model="multicastEntryForm.srcip"
                      placeholder="source ip address"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters('ip', multicastEntryForm.srcip)
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("ip", multicastEntryForm.srcip) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="vlan">VLan</label>
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'vlan',
                        multicastEntryForm.vlan
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="vlan"
                      v-model="multicastEntryForm.vlan"
                      placeholder="INTEGER<1-4094>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'vlan',
                          multicastEntryForm.vlan
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("vlan", multicastEntryForm.vlan) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="port"
                    >Ethernet Port</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'port',
                        multicastEntryForm.port
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="port"
                      v-model="multicastEntryForm.port"
                      placeholder="INTEGER<1-24>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'port',
                          multicastEntryForm.port
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("port", multicastEntryForm.port) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="bandwidth"
                    >Bandwidth</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'bandwidth',
                        multicastEntryForm.bandwidth
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="bandwidth"
                      v-model="multicastEntryForm.bandwidth"
                      placeholder="INTEGER<1-1024000>(kbps)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'bandwidth',
                          multicastEntryForm.bandwidth
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters(
                          "bandwidth",
                          multicastEntryForm.bandwidth
                        )
                      }}
                    </small>
                  </div>
                </div>

                <div v-if="multicastEntryForm.type == '3'" class="form-group">
                  <label class="col-sm-3 control-label" for="duration"
                    >Duration</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'duration',
                        multicastEntryForm.duration
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="duration"
                      v-model="multicastEntryForm.duration"
                      placeholder="INTEGER<10-6000>(s)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'duration',
                          multicastEntryForm.duration
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters("duration", multicastEntryForm.duration)
                      }}
                    </small>
                  </div>
                </div>

                <div v-if="multicastEntryForm.type == '3'" class="form-group">
                  <label class="col-sm-3 control-label" for="interval"
                    >Interval</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'interval',
                        multicastEntryForm.interval
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="interval"
                      v-model="multicastEntryForm.interval"
                      placeholder="INTEGER<1-7200>(s)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'interval',
                          multicastEntryForm.interval
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters("interval", multicastEntryForm.interval)
                      }}
                    </small>
                  </div>
                </div>
                <div v-if="multicastEntryForm.type == '3'" class="form-group">
                  <label class="col-sm-3 control-label" for="resettime"
                    >Reset Time</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'resettime',
                        multicastEntryForm.resettime
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="resettime"
                      v-model="multicastEntryForm.resettime"
                      placeholder="INTEGER<1-255>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'resettime',
                          multicastEntryForm.resettime
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters(
                          "resettime",
                          multicastEntryForm.resettime
                        )
                      }}
                    </small>
                  </div>
                </div>
                <div v-if="multicastEntryForm.type == '3'" class="form-group">
                  <label class="col-sm-3 control-label" for="times"
                    >Times</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'times',
                        multicastEntryForm.times
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="times"
                      v-model="multicastEntryForm.times"
                      placeholder="INTEGER<1-255>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'times',
                          multicastEntryForm.times
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("times", multicastEntryForm.times) }}
                    </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "profileMulticastEnrty",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      profileId: this.$route.query.profileId,
      multicastEntryTable: "",
      entryIndx: "",
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      multicastEntryInfo: "",
      multicastEntryForm: {
        index: "",
        type: "",
        startip: "",
        endip: "",
        srcip: "",
        vlan: "",
        port: "",
        bandwidth: "",
        duration: "",
        interval: "",
        resettime: "",
        times: "",
      },
    }
  },

  created() {
    this.loadmulticastProfileEntry()
  },

  methods: {
    loadmulticastProfileEntry() {
      get("multicastProfileEntry?mcastIdx=" + this.profileId)
        .then((res) => (this.multicastEntryTable = res.data))
        .catch((err) => {
          this.multicastEntryTable = en.multicastEntryTable
        })
    },
    getEntryInfo(index) {
      this.$router.push({
        path: "/profilemulticastentryinfo",
        name: "profileMulticastEntryInfo",
        query: { mcastIdx: this.profileId, entryIdx: index },
      })
    },
    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },

    clkEdit() {
      this.resetField()
      for (let i = 0; i < this.multicastEntryTable.data.length; i++) {
        if (this.multicastEntryTable.data[i].selected) {
          get(
            "multicastProfileEntryInfo?mcastIdx=" +
              this.profileId +
              "&entryIdx=" +
              this.multicastEntryTable.data[i].index
          )
            .then((res) => {
              this.multicastEntryInfo = res.data
              this.multicastEntryForm.index = this.multicastEntryInfo.index.v
              if (this.multicastEntryInfo.type.v == "permit") {
                this.multicastEntryForm.type = 2
              } else {
                this.multicastEntryForm.type = 3
              }
              this.multicastEntryForm.startip =
                this.multicastEntryInfo.startip.v
              this.multicastEntryForm.endip = this.multicastEntryInfo.endip.v
              this.multicastEntryForm.srcip = this.multicastEntryInfo.srcip.v
              this.multicastEntryForm.vlan = this.multicastEntryInfo.vlan.v
              this.multicastEntryForm.port = this.multicastEntryInfo.port.v
              this.multicastEntryForm.bandwidth =
                this.multicastEntryInfo.bandwidth.v
              this.multicastEntryForm.duration =
                this.multicastEntryInfo.duration.v
              this.multicastEntryForm.interval =
                this.multicastEntryInfo.interval.v
              this.multicastEntryForm.resettime =
                this.multicastEntryInfo.resettime.v
              this.multicastEntryForm.times = this.multicastEntryInfo.times.v
            })
            .catch((err) => {})

          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.multicastEntryTable.data.length; i++) {
        if (this.multicastEntryTable.data[i].selected) {
          list.push({
            programIndex: Number(this.multicastEntryTable.data[i].index),
          })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["multicastID"] = Number(this.profileId)
      delData["indexList"] = list
      post("multicastProfileEntryDelete", delData)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadmulticastProfileEntry()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.loadmulticastProfileEntry()
          this.showAlertBox("critical", "error", err)
        })
    },

    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var multicastEntryFormTmp = {
        index: "",
        type: "",
        startip: "",
        endip: "",
        srcip: "",
        vlan: "",
        port: "",
        bandwidth: "",
        duration: "",
        interval: "",
        resettime: "",
        times: "",
      }
      this.multicastEntryForm = multicastEntryFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.multicastEntryTable.data.length; i++) {
        if (this.isSelectAll) {
          this.multicastEntryTable.data[i].selected = true
        } else {
          this.multicastEntryTable.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.multicastEntryTable.data.length; i++) {
        this.multicastEntryTable.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var multicastEntry = {
        multicastid: Number(this.profileId),
        index: Number(this.multicastEntryForm.index),
        type: Number(this.multicastEntryForm.type),
        startip: this.multicastEntryForm.startip,
        endip: this.multicastEntryForm.endip,
        srcip: this.multicastEntryForm.srcip,
        vlan: Number(this.multicastEntryForm.vlan),
        port: Number(this.multicastEntryForm.port),
        bandwidth: Number(this.multicastEntryForm.bandwidth),
        duration: Number(this.multicastEntryForm.duration),
        interval: Number(this.multicastEntryForm.interval),
        resettime: Number(this.multicastEntryForm.resettime),
        times: Number(this.multicastEntryForm.times),
      }
      if (this.isEditClik == false) {
        for (let i = 0; i < this.multicastEntryTable.data.length; i++) {
          if (multicastEntry.index == this.multicastEntryTable.data[i].index) {
            this.showAlertBox("warn", "Message", "This index has been created")
            return
          }
        }
      }

      if (
        this.multicastEntryForm.index == "" ||
        this.multicastEntryForm.type == "" ||
        this.multicastEntryForm.startip == "" ||
        this.checkParameters("index", this.multicastEntryForm.index) ||
        this.checkParameters("ip", this.multicastEntryForm.startip)
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      if (this.multicastEntryForm.vlan == "") {
        multicastEntry.vlan = -1
      } else {
        if (this.checkParameters("vlan", this.multicastEntryForm.vlan)) {
          this.showAlertBox("warn", "Message", "Invalid vlan")
          return
        }
      }
      if (this.multicastEntryForm.port == "") {
        multicastEntry.port = -1
      } else {
        if (this.checkParameters("port", this.multicastEntryForm.port)) {
          this.showAlertBox("warn", "Message", "Invalid port")
          return
        }
      }
      if (this.multicastEntryForm.bandwidth == "") {
        multicastEntry.bandwidth = -1
      } else {
        if (
          this.checkParameters("bandwidth", this.multicastEntryForm.bandwidth)
        ) {
          this.showAlertBox("warn", "Message", "Invalid bandwidth")
          return
        }
      }
      if (this.multicastEntryForm.duration == "") {
        multicastEntry.duration = -1
      } else {
        if (
          this.checkParameters("duration", this.multicastEntryForm.duration)
        ) {
          this.showAlertBox("warn", "Message", "Invalid duration")
          return
        }
      }
      if (this.multicastEntryForm.interval == "") {
        multicastEntry.interval = -1
      } else {
        if (
          this.checkParameters("interval", this.multicastEntryForm.interval)
        ) {
          this.showAlertBox("warn", "Message", "Invalid interval")
          return
        }
      }
      if (this.multicastEntryForm.resettime == "") {
        multicastEntry.resettime = -1
      } else {
        if (
          this.checkParameters("resettime", this.multicastEntryForm.resettime)
        ) {
          this.showAlertBox("warn", "Message", "Invalid resetTime")
          return
        }
      }
      if (this.multicastEntryForm.times == "") {
        multicastEntry.times = -1
      } else {
        if (this.checkParameters("times", this.multicastEntryForm.times)) {
          this.showAlertBox("warn", "Message", "Invalid times")
          return
        }
      }

      post("multicastProfileEntryConfig", multicastEntry)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadmulticastProfileEntry()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
    },

    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "index") {
        if (isNaN(Number(value)) || Number(value) < 0 || Number(value) > 127) {
          return "index must be in range 0-127"
        }
      } else if (type == "ip") {
        if (
          value.match(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/) == null
        ) {
          return "ip address must be inputted with A.B.C.D "
        } else {
          var id = value.split(".")
          let ip0 = Number(id[0])
          let ip1 = Number(id[1])
          let ip2 = Number(id[2])
          let ip3 = Number(id[3])
          if (
            ip0 < 0 ||
            ip0 > 255 ||
            ip1 < 0 ||
            ip1 > 255 ||
            ip2 < 0 ||
            ip2 > 255 ||
            ip3 < 0 ||
            ip3 > 255 ||
            (ip0 == 0 && ip1 == 0 && ip2 == 0 && ip3 == 0)
          )
            return "invalid ip address"
        }
      } else if (type == "vlan") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 4094) {
          return "vlan must be in range 1-4094"
        }
      } else if (type == "port") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 24) {
          return "port must be in range 1-24"
        }
      } else if (type == "bandwidth") {
        if (
          isNaN(Number(value)) ||
          Number(value) < 1 ||
          Number(value) > 1024000
        ) {
          return "bandwidth must be in range 1-1024000"
        }
      } else if (type == "duration") {
        if (
          isNaN(Number(value)) ||
          Number(value) < 10 ||
          Number(value) > 6000
        ) {
          return "duration must be in range 10-6000"
        }
      } else if (type == "interval") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 7200) {
          return "interval must be in range 1-7200"
        }
      } else if (type == "resettime") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 255) {
          return "resetTime must be in range 1-255"
        }
      } else if (type == "times") {
        if (isNaN(Number(value)) || Number(value) < 1 || Number(value) > 255) {
          return "times must be in range 1-255"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
